import { useLocation, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './Utilities/authContext';
import PrivateRoute from './privateRoute';

import Login from './Pages/Login';
import Dashboard from './Pages/Dashboard';
import AccountGroupDetail from './Pages/AccountGroupDetail';
import AccountDetail from './Pages/AccountDetail';
import LoginDetail from './Pages/LoginDetail';
import UploadProgress from './Pages/UploadProgress';
import PrivacyPolicy from './Pages/Extra/PrivacyPolicy';
import TermsOfService from './Pages/Extra/TermsOfService';

function InnerApp() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <AuthProvider>
      {isHomePage ? (
        <Routes>
          <Route path="/" element={<Login />} />
        </Routes>
      ) : (
        <Routes>
          <Route
            path="/dashboard"
            element={<PrivateRoute element={<Dashboard />} elName="dashboard" />}
          />
          <Route
            path="/groups/:groupId"
            element={<PrivateRoute element={<AccountGroupDetail />} elName="dashboard" />}
          />
          <Route
            path="/accounts/:accountId"
            element={<PrivateRoute element={<AccountDetail />} elName="dashboard" />}
          />
          <Route
            path="/logins/:loginId"
            element={<PrivateRoute element={<LoginDetail />} elName="dashboard" />}
          />
          <Route
            path="/upload-jobs/:jobId"
            element={<PrivateRoute element={<UploadProgress />} elName="dashboard" />}
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>
      )}
    </AuthProvider>
  );
}

export default InnerApp;
